import { map } from 'lodash';
import { PropertyType } from '../types';
import { replaceFirst } from '../../view/pages/GamblingReport/GamblingReport.helper';

export const getInitialColumns = (list: PropertyType[]): string[] => map(list, 'label');

export const getColumns = (key: string, defaultValues: PropertyType[]): string[] => {
	const initialColumns = getInitialColumns(defaultValues);
	try {
		const saved = localStorage.getItem(key);
		if (saved !== null) {
			const columns = replaceFirst(JSON.parse(saved), initialColumns[0]);
			const filtered = columns.filter((f) => initialColumns.includes(f));
			return filtered;
		}
		return initialColumns;
	} catch {
		return initialColumns;
	}
};
